import { Directive, inject, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { ClientDroits } from "@jack-sparrow-libraries/emotion-models";

@Directive({
	selector: "[hasRestrictedAccess]",
	standalone: true,
})
export class HasRestrictedAccessDirective {
	private readonly templateRef = inject(TemplateRef);
	private readonly viewContainer = inject(ViewContainerRef);

	@Input("hasRestrictedAccess") set setDroits(droits: ClientDroits) {
		this.viewContainer.clear();
		if (
			droits &&
			(droits === ClientDroits.Remplacant_Sans_Acces_Donnees ||
				droits === ClientDroits.Remplacant_Acces_Personnalise)
		) {
			const viewRef = this.viewContainer.createEmbeddedView(this.templateRef);
			viewRef.detectChanges();
		}
	}
}
